export class BuilderAttachment {
  name: string;
  guid: string;

  constructor(name: string, guid: string) {
    this.name = name;
    this.guid = guid;
  }
}
